import { register } from '../apiRegistry';

const getStudentId = () => localStorage.getItem('studentId');
const getUserInfo = () => {
  try {
    return JSON.parse(localStorage.getItem('userConfig') ?? '');
  } catch {
    return null;
  }
};

register({

});
